module.exports = __webpack_public_path__ + "img/bgc1.499b0405.png";